var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-region"},[_c('div',{staticClass:"label-area"},[_c('div',{staticClass:"label-container"},[(_vm.image.imgUrl)?_c('img',{ref:"img",style:({
            top: _vm.imageStyle.top + 'px',
            left: _vm.imageStyle.left + 'px',
            width: _vm.imageStyle.width + 'px',
            height: _vm.imageStyle.height + 'px'
          }),attrs:{"src":_vm.image.imgUrl,"alt":""},on:{"load":_vm.imageLoad}}):_vm._e(),_c('div',{ref:"container",staticClass:"label-container-box",style:({
            top: _vm.imageStyle.top + 'px',
            left: _vm.imageStyle.left + 'px',
            width: _vm.imageStyle.width + 'px',
            height: _vm.imageStyle.height + 'px'
          })},_vm._l((_vm.regionList),function(region,index){return _c('div',{key:index},[(region.isShow)?_c('div',{class:[
                'label-box',
                _vm.ActionTool.action == 'label' &&
                _vm.activeRegion == index &&
                region.myKey != 'noTarget'
                  ? 'active'
                  : ''
              ],style:({
                border: `2px solid ${region.labelColor}`,
                top: region.t + '%',
                left: region.l + '%',
                width: region.w + '%',
                height: region.h + '%'
              }),attrs:{"data-index":index},on:{"click":function($event){return _vm.onActive(index)}}}):_vm._e()])}),0)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }